import React, { useEffect, useState } from "react";
import * as Constants from "../../../../Constants/index";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Oval from "../../loader/CircleLoade";
import Navbar from "../../../common/Navbar";
import Footer from "../../../common/Footer";

export default function ProductWiseSummary() {
  const navigate = useNavigate();
  const token = localStorage.getItem("token");
  const [loading, setLoading] = useState(false);

  // Quarters and Product Summary states
  const [quartersList, setQuartersList] = useState([]);
  const [selectedQuarterCode, setSelectedQuarterCode] = useState("Q1");
  const [selectedCategory, setSelectedCategory] = useState("Pipes and Fittings");
  const [productSummaryData, setProductSummaryData] = useState(null);

  useEffect(() => {
    if (!token) {
      navigate("/");
      return;
    }
    getQuarters();
  }, []);

  const getQuarters = async () => {
    const token = localStorage.getItem("token");
    if (!token) return;
    setLoading(true);
    try {
      const res = await axios.get(
        `${Constants.baseUrl}purchase/retailer/invoice/quarters`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Accept-Language": localStorage.getItem("langauge"),
            appVersion: Constants.av,
            platform: Constants.pt,
            company: Constants.company,
            program: Constants.program2,
          },
        }
      );
      const dt = res.data;
      if (dt?.result === "success" && dt?.output?.quarters?.length > 0) {
        setQuartersList(dt.output.quarters);
        const firstQ = dt.output.quarters[0].quarter;
        setSelectedQuarterCode(firstQ);
        getProductSummary(firstQ, selectedCategory);
      } else {
        setLoading(false);
      }
    } catch (err) {
      console.log("Error fetching quarters", err);
      setLoading(false);
    }
  };

  const getProductSummary = async (quarterCode, category) => {
    const token = localStorage.getItem("token");
    if (!token) return;
    setLoading(true);
    try {
      const res = await axios.get(
        `${Constants.baseUrl}purchase/retailer/invoice/product-summary?quarter=${quarterCode}&category=${encodeURIComponent(category)}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Accept-Language": localStorage.getItem("langauge"),
            appVersion: Constants.av,
            platform: Constants.pt,
            company: Constants.company,
            program: Constants.program2,
          },
        }
      );
      const dt = res.data;
      if (dt?.result === "success" && dt?.output) {
        setProductSummaryData(dt.output);
      } else {
        setProductSummaryData(null);
      }
    } catch (err) {
      console.log("Error fetching product summary", err);
      setProductSummaryData(null);
    } finally {
      setLoading(false);
    }
  };

  const handleQuarterChange = (e) => {
    const qCode = e.target.value;
    setSelectedQuarterCode(qCode);
    getProductSummary(qCode, selectedCategory);
  };

  const handleCategoryTab = (cat) => {
    setSelectedCategory(cat);
    getProductSummary(selectedQuarterCode, cat);
  };

  return (
    <>
      {loading ? <Oval /> : null}
      <Navbar />

      <section className="page-content--bge55">
        <div className="container">
          {/* Header Row */}
          <div className="row mb-20" style={{ marginBottom: "20px" }}>
            <div className="col-md-12">
              <h3 className="head1" style={{ color: "#0f2d6b", fontWeight: "700" }}>
                Product Wise Summary
              </h3>
            </div>
          </div>

          {/* Main Card Container */}
          <div
            style={{
              backgroundColor: "#ffffff",
              borderRadius: "16px",
              padding: "24px",
              boxShadow: "0 4px 20px rgba(0,0,0,0.06)",
              border: "1px solid #e2e8f0",
              marginBottom: "30px",
            }}
          >
            {/* Dealer & Quarter Filter Header Box */}
            <div
              style={{
                backgroundColor: "#f8fafc",
                borderRadius: "14px",
                padding: "18px 20px",
                marginBottom: "20px",
                border: "1px solid #e2e8f0",
                display: "flex",
                flexWrap: "wrap",
                gap: "20px",
                alignItems: "center",
              }}
            >
              {/* Dealer Box */}
              <div style={{ flex: "1 1 240px" }}>
                <label
                  style={{
                    fontSize: "12px",
                    color: "#64748b",
                    fontWeight: "600",
                    marginBottom: "6px",
                    display: "block",
                  }}
                >
                  Dealer
                </label>
                <div
                  style={{
                    backgroundColor: "#e2e8f0",
                    borderRadius: "8px",
                    padding: "10px 14px",
                    fontSize: "13.5px",
                    fontWeight: "600",
                    color: "#334155",
                    minHeight: "42px",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  {productSummaryData?.dealerName || "—"}
                </div>
              </div>

              {/* Quarter Select Dropdown */}
              <div style={{ flex: "1 1 240px" }}>
                <label
                  style={{
                    fontSize: "12px",
                    color: "#64748b",
                    fontWeight: "600",
                    marginBottom: "6px",
                    display: "block",
                  }}
                >
                  Quarter
                </label>
                <select
                  value={selectedQuarterCode}
                  onChange={handleQuarterChange}
                  style={{
                    width: "100%",
                    backgroundColor: "#e2e8f0",
                    border: "none",
                    borderRadius: "8px",
                    padding: "10px 14px",
                    fontSize: "13.5px",
                    fontWeight: "600",
                    color: "#1e293b",
                    outline: "none",
                    cursor: "pointer",
                    height: "42px",
                  }}
                >
                  {quartersList.map((q) => (
                    <option key={`${q.quarter}-${q.startYear}`} value={q.quarter}>
                      {q.label || `${q.quarter} (${q.financialYear})`}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            {/* Category Switcher Tabs */}
            <div
              style={{
                display: "flex",
                borderBottom: "2px solid #e2e8f0",
                marginBottom: "24px",
                gap: "28px",
              }}
            >
              <button
                onClick={() => handleCategoryTab("Pipes and Fittings")}
                style={{
                  background: "none",
                  border: "none",
                  padding: "12px 4px",
                  fontSize: "15px",
                  fontWeight:
                    selectedCategory === "Pipes and Fittings" ? "700" : "500",
                  color:
                    selectedCategory === "Pipes and Fittings"
                      ? "#52b8b8"
                      : "#64748b",
                  borderBottom:
                    selectedCategory === "Pipes and Fittings"
                      ? "3px solid #52b8b8"
                      : "3px solid transparent",
                  cursor: "pointer",
                  marginBottom: "-2px",
                  transition: "all 0.2s ease",
                }}
              >
                Pipes &amp; Fittings
              </button>

              <button
                onClick={() => handleCategoryTab("WST")}
                style={{
                  background: "none",
                  border: "none",
                  padding: "12px 4px",
                  fontSize: "15px",
                  fontWeight: selectedCategory === "WST" ? "700" : "500",
                  color: selectedCategory === "WST" ? "#52b8b8" : "#64748b",
                  borderBottom:
                    selectedCategory === "WST"
                      ? "3px solid #52b8b8"
                      : "3px solid transparent",
                  cursor: "pointer",
                  marginBottom: "-2px",
                  transition: "all 0.2s ease",
                }}
              >
                WST
              </button>
            </div>

            {/* Sub-Title */}
            <h4
              style={{
                fontSize: "16px",
                fontWeight: "700",
                color: "#1e293b",
                marginBottom: "16px",
              }}
            >
              Product Wise Summary
            </h4>

            {/* Data Table */}
            <div
              className="table-responsive"
              style={{
                borderRadius: "12px",
                overflow: "hidden",
                border: "1px solid #e2e8f0",
              }}
            >
              <table className="table" style={{ margin: 0 }}>
                <thead>
                  <tr
                    style={{
                      backgroundColor: "#52b8b8",
                      color: "#ffffff",
                    }}
                  >
                    <th
                      style={{
                        padding: "12px 16px",
                        fontWeight: "700",
                        border: "none",
                        color: "#ffffff",
                        fontSize: "13.5px",
                      }}
                    >
                      Month
                    </th>
                    {productSummaryData?.productHeaders?.map((header) => (
                      <th
                        key={header}
                        style={{
                          padding: "12px 16px",
                          fontWeight: "700",
                          border: "none",
                          color: "#ffffff",
                          textAlign: "right",
                          fontSize: "13.5px",
                        }}
                      >
                        {header}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {!productSummaryData?.productHeaders?.length ||
                  !productSummaryData?.results ||
                  productSummaryData.results.length === 0 ? (
                    <tr>
                      <td
                        colSpan={
                          productSummaryData?.productHeaders?.length
                            ? 1 + productSummaryData.productHeaders.length
                            : 1
                        }
                        style={{
                          textAlign: "center",
                          padding: "32px 16px",
                          color: "#64748b",
                          fontSize: "14.5px",
                          fontWeight: "600",
                        }}
                      >
                        No Data Found
                      </td>
                    </tr>
                  ) : (
                    productSummaryData.results.map((row, idx) => (
                      <tr
                        key={row.month || idx}
                        style={{
                          backgroundColor:
                            idx % 2 === 0 ? "#ffffff" : "#f8fafc",
                        }}
                      >
                        <td
                          style={{
                            padding: "12px 16px",
                            fontWeight: "600",
                            color: "#334155",
                            fontSize: "13.5px",
                          }}
                        >
                          {row.month}
                        </td>
                        {productSummaryData?.productHeaders?.map((header) => (
                          <td
                            key={header}
                            style={{
                              padding: "12px 16px",
                              textAlign: "right",
                              color: "#1e293b",
                              fontSize: "13.5px",
                            }}
                          >
                            {row.productValues?.[header] !== undefined
                              ? row.productValues[header]
                              : 0}
                          </td>
                        ))}
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>

            {/* Summary Metrics Below Table */}
            <div
              style={{
                marginTop: "20px",
                display: "flex",
                flexWrap: "wrap",
                gap: "16px",
              }}
            >
              {selectedCategory === "Pipes and Fittings" ? (
                <>
                  {/* Total Sales Value Card */}
                  <div
                    style={{
                      flex: "1 1 240px",
                      backgroundColor: "#f1f5f9",
                      borderRadius: "14px",
                      padding: "16px 20px",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <div>
                      <span
                        style={{
                          fontSize: "12px",
                          color: "#64748b",
                          fontWeight: "600",
                        }}
                      >
                        Total Sales Value
                      </span>
                      <div
                        style={{
                          fontSize: "18px",
                          fontWeight: "700",
                          color: "#0f172a",
                          marginTop: "4px",
                        }}
                      >
                        ₹{productSummaryData?.totalSalesValue ?? 0}
                      </div>
                    </div>
                    <div
                      style={{
                        width: "40px",
                        height: "40px",
                        borderRadius: "50%",
                        backgroundColor: "#e2e8f0",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <i
                        className="fa fa-bar-chart"
                        style={{
                          color: "#3b82f6",
                          fontSize: "18px",
                        }}
                      ></i>
                    </div>
                  </div>

                  {/* Total Considered in Hamesha Card */}
                  <div
                    style={{
                      flex: "1 1 240px",
                      backgroundColor: "#f1f5f9",
                      borderRadius: "14px",
                      padding: "16px 20px",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <div>
                      <span
                        style={{
                          fontSize: "12px",
                          color: "#64748b",
                          fontWeight: "600",
                        }}
                      >
                        Total Considered in Hamesha
                      </span>
                      <div
                        style={{
                          fontSize: "18px",
                          fontWeight: "700",
                          color: "#0f172a",
                          marginTop: "4px",
                        }}
                      >
                        {productSummaryData?.totalConsideredInHamesha ?? 0} INR
                      </div>
                    </div>
                    <div
                      style={{
                        width: "40px",
                        height: "40px",
                        borderRadius: "50%",
                        backgroundColor: "#dcfce7",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <i
                        className="fa fa-check-circle"
                        style={{
                          color: "#22c55e",
                          fontSize: "20px",
                        }}
                      ></i>
                    </div>
                  </div>
                </>
              ) : (
                /* WST Category Card: Total Net Litres */
                <div
                  style={{
                    flex: "1 1 240px",
                    maxWidth: "300px",
                    backgroundColor: "#f1f5f9",
                    borderRadius: "14px",
                    padding: "16px 20px",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <div>
                    <span
                      style={{
                        fontSize: "12px",
                        color: "#64748b",
                        fontWeight: "600",
                      }}
                    >
                      Total Net Litres
                    </span>
                    <div
                      style={{
                        fontSize: "18px",
                        fontWeight: "700",
                        color: "#0f172a",
                        marginTop: "4px",
                      }}
                    >
                      {productSummaryData?.totalNetLitres ?? 0}
                    </div>
                  </div>
                  <div
                    style={{
                      width: "40px",
                      height: "40px",
                      borderRadius: "50%",
                      backgroundColor: "#dcfce7",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <i
                      className="fa fa-tint"
                      style={{
                        color: "#22c55e",
                        fontSize: "20px",
                      }}
                    ></i>
                  </div>
                </div>
              )}
            </div>

            {/* Footer Information Notice */}
            <div
              style={{
                marginTop: "20px",
                backgroundColor: "#e6f7f7",
                borderRadius: "12px",
                padding: "12px 16px",
                display: "flex",
                alignItems: "center",
                gap: "10px",
              }}
            >
              <div
                style={{
                  width: "22px",
                  height: "22px",
                  borderRadius: "50%",
                  border: "2px solid #52b8b8",
                  color: "#52b8b8",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontWeight: "bold",
                  fontSize: "12px",
                  flexShrink: 0,
                }}
              >
                i
              </div>
              <span
                style={{
                  fontSize: "13px",
                  color: "#277575",
                  fontWeight: "500",
                }}
              >
                Values are calculated for the selected quarter and category
              </span>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
}
